import type { LaborPresence } from "@/lib/labor/laborPresence";
import { hubLaborExpectedPageFromPathname, laborPageKeysEquivalent } from "@/lib/labor/laborPageKey";

export type LaborLockdownDecision = "render" | "lockdown";

export function decideLaborLockdown(input: {
  presence: LaborPresence | null;
  currentTabId: string;
  currentPathname: string;
  currentSearch?: string;
}): LaborLockdownDecision {
  const { presence, currentTabId, currentPathname, currentSearch = "" } = input;
  if (presence === null) {
    return "render";
  }
  if (presence.tabId === null) {
    return "lockdown";
  }
  if (presence.tabId !== currentTabId) {
    return "lockdown";
  }
  const expectedPage = hubLaborExpectedPageFromPathname(currentPathname, currentSearch);
  if (!laborPageKeysEquivalent(presence.page, expectedPage)) {
    return "lockdown";
  }
  return "render";
}
